export { getElementInputValue, getSerializedNodeId, hasSerializedNode, nodeAndAncestorsHaveSerializedNode, } from './serializationUtils';
export { serializeDocument } from './serializeDocument';
export { serializeNodeWithId } from './serializeNode';
export { serializeAttribute } from './serializeAttribute';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/index.js
// module id = 59
// module chunks = 0